// extracted by mini-css-extract-plugin
module.exports = {"fontWavehaus":"LeftPane1_fontWavehaus__35I2W","fontPoppins":"LeftPane1_fontPoppins__3sDOc"};